exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "related-articles {\n  display: block;\n  position: relative;\n  width: 100%; }\n  related-articles > div {\n    margin-top: 2rem; }\n", ""]);

// exports
